import API from "../../axios.jsx";

// Mismo dominio de API que el resto de módulos (apimonitoreo.vspamazonas.com.co),
// con su propia ruta base — igual patrón que BASE en bacSarampionAPI.js.
const BASE = "/consentimiento";

// El interceptor global de axios.jsx solo adjunta el token en rutas
// /bac — para /consentimiento hay que ponerlo a mano en cada llamada
// que sí lo necesita (todo lo del panel admin), leyéndolo de donde
// ConsentimientoAuthContext lo guarda al iniciar sesión.
const conToken = () => {
  const token = localStorage.getItem("consentimiento_token");
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

// ── Formulario público (sin token) ──
export const crearDisentimiento = (payload) => API.post(`${BASE}`, payload);

// ── Autenticación (públicas, sin token) ──
export const loginConsentimiento = (correo, password) => API.post(`${BASE}/auth/login`, { correo, password });
export const registroConsentimiento = (datos) => API.post(`${BASE}/auth/registro`, datos);

// ── Panel administrativo (con token) ──
export const getDisentimientos = (filtros = {}) => API.get(`${BASE}`, { params: filtros, ...conToken() });
export const getDisentimiento = (id) => API.get(`${BASE}/${id}`, conToken());
export const generarFichaDisentimiento = (id) => API.post(`${BASE}/${id}/generar-ficha`, {}, conToken());
export const eliminarDisentimiento = (id) => API.delete(`${BASE}/${id}`, conToken());

// ── Gestión de usuarios (con token, admin) ──
export const getUsuariosConsentimiento = () => API.get(`${BASE}/auth/usuarios`, conToken());
export const actualizarUsuarioConsentimiento = (id, datos) => API.put(`${BASE}/auth/usuarios/${id}`, datos, conToken());